import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './shared/styles/globals.css';
import './shared/styles/theme-dev.css';
import './shared/styles/theme-liberty.css';
import './shared/styles/liberty.css';
import { IS_DEV_BUILD, BRAND_NAME } from './shared/config/flavor';
import App from './app';

// Flavor no <html>: cada tema (dev preto+dourado / liberty prata+ouro+azul)
// so' aplica com o seu data-flavor.
// Cabal Next: os dois builds usam o azul do Liberty (mesma cor da marca Next) -- o
// painel do build dev deixa o preto+dourado (theme-dev.css segue no projeto, sem uso).
document.documentElement.dataset.flavor = 'liberty';
// Titulo da aba pela marca do build (Cabal Liberty / Cabal).
document.title = IS_DEV_BUILD ? `${BRAND_NAME} · Painel` : BRAND_NAME;

// Site instalável (dono 2026-10-20): o service worker do push (/sw.js) já registra ao abrir, não só ao ativar as
// notificações -- o "Instalar app" do navegador e o botão do painel GM (InstallAppButton) dependem dele.
// 'beforeinstallprompt' sai cedo: guardado aqui pro botão usar depois.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as any).__nextInstallPrompt = e;
  window.dispatchEvent(new Event('next-install-ready'));
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
